import { default as Spacer } from './Spacer';

export default Spacer;
